// Public account and legal routes that are already in the sitemap.
// Static HTML so a non-JS crawler does not see the home page title.
// The React screens still take over when JavaScript runs.

export const SIMPLE_PAGES = [
  {
    path: '/signup',
    title: 'Create an account — The WasteGame',
    description: 'Create a free customer account to post a job, or a carrier account if you have a waste carrier registration number. Posting does not book a van.',
    h1: 'Create an account',
    paragraphs: [
      'Customers post rubbish, clearance and scrap jobs. Carriers enter a waste carrier registration number. A carrier cannot send a price until an admin approves the account.',
      'Posting is free. It does not book a van, and it does not mean anyone will send a price. The WasteGame does not collect waste and holds no waste carrier licence.',
    ],
  },
  {
    path: '/customer-signup',
    title: 'Customer sign up — The WasteGame',
    description: 'Open a free customer account to post a rubbish or house clearance job in South Wales. You pay by card only after a priced job is marked complete.',
    h1: 'Customer sign up',
    paragraphs: [
      'A customer account is free. Use it to describe the waste and where it is. Posting does not book a van, and it does not mean anyone will send a price.',
      'On a priced job you pay by card after the job is marked complete. There is no customer fee.',
    ],
  },
  {
    path: '/provider-signup',
    title: 'Carrier sign up — The WasteGame',
    description: 'Create a carrier account and enter a waste carrier registration number. You cannot send a price until an admin approves the account.',
    h1: 'Carrier sign up',
    paragraphs: [
      'You will be asked for a waste carrier registration number. The account cannot send a price until an admin approves it. The admin screen links to the public registers. The site does not query those registers itself.',
      'The WasteGame does not collect waste and holds no waste carrier licence.',
    ],
  },
  {
    path: '/login',
    title: 'Log in — The WasteGame',
    description: 'Log in to post a job or, once an admin has approved your carrier account, to send a price. The WasteGame does not collect waste.',
    h1: 'Log in',
    paragraphs: [
      'Customers come back here to post a job and to pay by card after a priced job is marked complete. Carriers come back here to send a price, if an admin has approved the account.',
    ],
  },
  {
    path: '/terms',
    title: 'Terms of Service — The WasteGame',
    description: 'Terms for using The WasteGame, the marketplace that connects customers with waste carriers. The site does not collect waste and holds no waste carrier licence.',
    h1: 'Terms of Service',
    paragraphs: [
      'The WasteGame is a marketplace. It connects customers with waste carriers. It does not collect waste itself.',
      'Posting a job is free. It does not book a van. On a priced job the customer pays by card after the job is marked complete.',
    ],
  },
  {
    path: '/privacy',
    title: 'Privacy Policy — The WasteGame',
    description: 'How The WasteGame handles the information you give when you post a job or create a carrier account.',
    h1: 'Privacy Policy',
    paragraphs: [
      'This page explains what the site stores when you create an account or post a job. Read it before you sign up.',
    ],
  },
  {
    path: '/carrier-agreement',
    title: 'Carrier Agreement — The WasteGame',
    description: 'Rules for carriers on The WasteGame. Carriers pay a 5% commission on paid jobs. Customers are not charged a fee.',
    h1: 'Carrier Agreement',
    paragraphs: [
      'This agreement is for waste carriers who send prices on The WasteGame. A carrier types a registration number at sign up and cannot send a price until an admin approves the account.',
      'On paid jobs the platform commission is 5%. Scrap collection has no cost to the customer.',
    ],
  },
];
